export function isMobile(): boolean {
  if (navigator) {
    const userAgent = navigator.userAgent;
    return !!(userAgent && (
      !!userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|(Windows Phone)/i)
    ));
  }
  return false;
}
